var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('patrolStatistics',{ref:"patrolStatistics",attrs:{"viewType":"1","tableHeader":_vm.tableHead}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }